import React from 'react'
import { StyledPageRoot } from './styles'

interface PageRootProps {
    children: React.ReactNode
}

export default function PageRoot({ children }: PageRootProps) {
    return <StyledPageRoot>{children}</StyledPageRoot>
}
